export const ACTION_COLOR_TOKENS = [
  {
    id: 1,
    color: '#10B981',
    lightBg: '#ECFDF5',
    landingUrl: 'https://www.commit2act.org/plant-based-eating',
  },
  {
    id: 2,
    color: '#14B8A6',
    lightBg: '#F0FDFA',
    landingUrl: 'https://www.commit2act.org/sustainable-transportation',
  },
  {
    id: 3,
    color: '#06B6D4',
    lightBg: '#ECFEFF',
    landingUrl: 'https://www.commit2act.org/avoid-plastic',
  },
  {
    id: 5,
    color: '#34D399',
    lightBg: '#D1FAE5',
    landingUrl: 'https://www.commit2act.org/plant-a-garden',
  },
  {
    id: 11,
    color: '#F59E0B',
    lightBg: '#FFFBEB',
    landingUrl: 'https://www.commit2act.org/avoid-fast-fashion',
  },
  {
    id: 12,
    color: '#FBBF24',
    lightBg: '#FFFBEB',
    landingUrl: 'https://www.commit2act.org/wash-in-cold-water',
  },
  {
    id: 13,
    color: '#84CC16',
    lightBg: '#F7FEE7',
    landingUrl: 'https://ocean.org/action/lead-a-shoreline-cleanup/',
  },
];

